import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.jsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../public/static/fonts/Inter/static/Inter-Light.ttf%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22../../../public/static/fonts/Inter/static/Inter-Regular.ttf%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../../public/static/fonts/Inter/static/Inter-Bold.ttf%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22../../../public/static/fonts/Inter/static/Inter-Black.ttf%22,%22weight%22:%22900%22,%22style%22:%22normal%22}],%22variable%22:%22--brand-font%22}],%22variableName%22:%22interFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'interFont', 'interFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
